import { NotificationAllDto } from '@app/data/dtos/notification/notification-all.dto';
import { NotificationDto } from '@app/data/dtos/notification/notification.dto';
import { Notification, NotificationAll } from '@app/entities/models/notifications/notification.model';

import { MapFromFn } from '@mercadona/common/public';
import { Builder } from '@mercadona/common/utils';

export const mapNotification: MapFromFn<NotificationDto, Notification> = (value) => {
  const builder = Builder.forModel(Notification)
    .userID(value.userID)
    .id(value.id)
    .title(value.title)
    .description(value.description)
    .action(value.action)
    .type(value.type)
    .status(value.status)
    .translationKey(value.translation_key);

  if (value.category !== null) {
    builder.category(value.category);
  }
  if (value.created !== null) {
    builder.created(value.created);
  }
  if (value.page !== null) {
    builder.page(value.page);
  }
  if (value.section !== null) {
    builder.section(value.section);
  }
  if (value.item_id !== null) {
    builder.item_id(value.item_id);
  }
  if (value.thumbnail !== null) {
    builder.thumbnail(value.thumbnail);
  }

  return builder.build();
};

export const mapDataNotification: MapFromFn<NotificationDto[], Notification[]> = (value) => value.map(mapNotification);

export const mapNotificationAll: MapFromFn<NotificationAllDto, NotificationAll> = (value) =>
  Builder.forModel(NotificationAll)
    .title(value?.title)
    .description(value?.description)
    .segmentDelay(value?.segment_delay)
    .build();
